<template>
  <div class="flex flex-col gap-5">
    <!-- Page Header -->
    <div class="flex items-center justify-between">
      <div>
        <h1 class="text-2xl font-bold text-slate-800">AI辅助科研项目管理系统 - 态势感知中心</h1>
        <p class="text-sm text-slate-500 mt-1">基于AI大模型的科研项目全生命周期智能管理与决策支持</p>
      </div>
      <div class="flex items-center gap-3">
        <span class="text-sm text-slate-500">{{ currentDate }}</span>
        <span class="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-cyan-400 text-white rounded-full text-xs font-semibold">AI驱动</span>
      </div>
    </div>

    <!-- AI智能体快捷交互区 - 新增 -->
    <div class="glass-card rounded-2xl p-5 bg-gradient-to-r from-purple-50/50 via-white to-blue-50/50">
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-2">
          <div class="w-10 h-10 rounded-xl bg-gradient-to-br from-purple-500 to-pink-500 flex items-center justify-center animate-pulse">
            <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
            </svg>
          </div>
          <div>
            <h3 class="text-base font-bold text-slate-800">🤖 AI智能体助手</h3>
            <p class="text-xs text-slate-500">基于RAG技术的项目管理智能辅助</p>
          </div>
        </div>
        <div class="flex items-center gap-2">
          <span class="px-2 py-1 bg-emerald-100 text-emerald-600 rounded text-xs font-medium">● 在线</span>
          <span class="text-xs text-slate-400">已处理 1,247 次查询</span>
        </div>
      </div>
      
      <!-- 智能体功能入口 -->
      <div class="grid grid-cols-4 gap-3 mb-4">
        <button @click="goToAIAssistant('qa')" class="ai-agent-card p-4 rounded-xl bg-white border border-purple-100 hover:border-purple-300 hover:shadow-lg transition-all group text-left">
          <div class="w-10 h-10 rounded-lg bg-purple-100 flex items-center justify-center mb-2 group-hover:bg-purple-500 transition-colors">
            <svg class="w-5 h-5 text-purple-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
            </svg>
          </div>
          <div class="text-sm font-semibold text-slate-800">智能问数</div>
          <div class="text-xs text-slate-500">自然语言查询项目数据</div>
        </button>

        <button @click="goToAIAssistant('review')" class="ai-agent-card p-4 rounded-xl bg-white border border-blue-100 hover:border-blue-300 hover:shadow-lg transition-all group text-left">
          <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center mb-2 group-hover:bg-blue-500 transition-colors">
            <svg class="w-5 h-5 text-blue-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <div class="text-sm font-semibold text-slate-800">材料审核</div>
          <div class="text-xs text-slate-500">AI自动审核申报材料</div>
        </button>

        <button @click="goToAIAssistant('expert')" class="ai-agent-card p-4 rounded-xl bg-white border border-emerald-100 hover:border-emerald-300 hover:shadow-lg transition-all group text-left">
          <div class="w-10 h-10 rounded-lg bg-emerald-100 flex items-center justify-center mb-2 group-hover:bg-emerald-500 transition-colors">
            <svg class="w-5 h-5 text-emerald-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
            </svg>
          </div>
          <div class="text-sm font-semibold text-slate-800">专家匹配</div>
          <div class="text-xs text-slate-500">智能推荐评审专家</div>
        </button>

        <button @click="goToAIAssistant('report')" class="ai-agent-card p-4 rounded-xl bg-white border border-amber-100 hover:border-amber-300 hover:shadow-lg transition-all group text-left">
          <div class="w-10 h-10 rounded-lg bg-amber-100 flex items-center justify-center mb-2 group-hover:bg-amber-500 transition-colors">
            <svg class="w-5 h-5 text-amber-600 group-hover:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
          </div>
          <div class="text-sm font-semibold text-slate-800">智能报告</div>
          <div class="text-xs text-slate-500">自动生成分析报告</div>
        </button>
      </div>
      
      <!-- 快捷提问 -->
      <div class="flex items-center gap-3">
        <div class="flex-1 relative">
          <input 
            type="text" 
            placeholder="试试问：本月申报项目中高熵催化领域有哪些？或：查询项目2025AI003的进度情况..."
            class="w-full pl-4 pr-12 py-3 rounded-xl border border-slate-200 focus:border-purple-400 focus:ring-2 focus:ring-purple-100 transition-all text-sm"
          />
          <button class="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-lg bg-purple-500 hover:bg-purple-600 flex items-center justify-center transition-colors">
            <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Key Metrics Cards -->
    <div class="grid grid-cols-4 gap-4">
      <div class="premium-metric-card rounded-2xl p-5 relative overflow-hidden group">
        <div class="absolute top-0 right-0 w-28 h-28 bg-blue-500/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-110 transition-transform duration-500"></div>
        <div class="relative z-10">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-slate-500 font-medium">项目总数</span>
            <div class="w-9 h-9 rounded-lg bg-blue-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
              </svg>
            </div>
          </div>
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">1,247</span>
            <span class="text-xs font-medium text-emerald-500 flex items-center gap-0.5">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
              </svg>
              +15% YoY
            </span>
          </div>
        </div>
      </div>

      <div class="premium-metric-card rounded-2xl p-5 relative overflow-hidden group">
        <div class="absolute top-0 right-0 w-28 h-28 bg-cyan-500/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-110 transition-transform duration-500"></div>
        <div class="relative z-10">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-slate-500 font-medium">进行中</span>
            <div class="w-9 h-9 rounded-lg bg-cyan-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-cyan-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
          </div>
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">856</span>
            <span class="text-xs font-medium text-emerald-500 flex items-center gap-0.5">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 10l7-7m0 0l7 7m-7-7v18"/>
              </svg>
              +8% MoM
            </span>
          </div>
        </div>
      </div>

      <div class="premium-metric-card rounded-2xl p-5 relative overflow-hidden group">
        <div class="absolute top-0 right-0 w-28 h-28 bg-purple-500/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-110 transition-transform duration-500"></div>
        <div class="relative z-10">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-slate-500 font-medium">在研经费</span>
            <div class="w-9 h-9 rounded-lg bg-purple-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
          </div>
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">3.2亿元</span>
          </div>
        </div>
      </div>

      <div class="premium-metric-card rounded-2xl p-5 relative overflow-hidden group">
        <div class="absolute top-0 right-0 w-28 h-28 bg-emerald-500/10 rounded-full -translate-y-1/2 translate-x-1/2 group-hover:scale-110 transition-transform duration-500"></div>
        <div class="relative z-10">
          <div class="flex items-center justify-between mb-2">
            <span class="text-sm text-slate-500 font-medium">本年已结题</span>
            <div class="w-9 h-9 rounded-lg bg-emerald-50 flex items-center justify-center">
              <svg class="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
            </div>
          </div>
          <div class="flex items-baseline gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">234</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Charts Row -->
    <div class="grid grid-cols-3 gap-5">
      <!-- 项目趋势折线图 -->
      <div class="glass-card rounded-2xl p-5">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-base font-bold text-slate-800">项目趋势分析</h3>
            <p class="text-xs text-slate-500 mt-0.5">2021-2025历年项目数量变化趋势</p>
          </div>
          <div class="flex items-center gap-2">
            <span class="w-2.5 h-2.5 rounded-full bg-blue-500"></span>
            <span class="text-xs text-slate-500">立项数</span>
            <span class="w-2.5 h-2.5 rounded-full bg-cyan-400 ml-2"></span>
            <span class="text-xs text-slate-500">结题数</span>
          </div>
        </div>
        <div class="h-48 relative">
          <svg class="w-full h-full" viewBox="0 0 400 200">
            <line x1="40" y1="20" x2="380" y2="20" stroke="#e2e8f0" stroke-width="1"/>
            <line x1="40" y1="60" x2="380" y2="60" stroke="#e2e8f0" stroke-width="1"/>
            <line x1="40" y1="100" x2="380" y2="100" stroke="#e2e8f0" stroke-width="1"/>
            <line x1="40" y1="140" x2="380" y2="140" stroke="#e2e8f0" stroke-width="1"/>
            <line x1="40" y1="180" x2="380" y2="180" stroke="#e2e8f0" stroke-width="1"/>
            <line x1="40" y1="180" x2="380" y2="180" stroke="#94a3b8" stroke-width="2"/>
            <line x1="40" y1="20" x2="40" y2="180" stroke="#94a3b8" stroke-width="2"/>
            <polyline fill="none" stroke="#3b82f6" stroke-width="3" points="70,140 130,110 190,90 250,60 310,40"/>
            <circle cx="70" cy="140" r="5" fill="#3b82f6"/>
            <circle cx="130" cy="110" r="5" fill="#3b82f6"/>
            <circle cx="190" cy="90" r="5" fill="#3b82f6"/>
            <circle cx="250" cy="60" r="5" fill="#3b82f6"/>
            <circle cx="310" cy="40" r="5" fill="#3b82f6"/>
            <polyline fill="none" stroke="#22d3ee" stroke-width="3" points="70,150 130,130 190,120 250,100 310,80"/>
            <circle cx="70" cy="150" r="5" fill="#22d3ee"/>
            <circle cx="130" cy="130" r="5" fill="#22d3ee"/>
            <circle cx="190" cy="120" r="5" fill="#22d3ee"/>
            <circle cx="250" cy="100" r="5" fill="#22d3ee"/>
            <circle cx="310" cy="80" r="5" fill="#22d3ee"/>
            <text x="70" y="195" text-anchor="middle" class="text-xs fill-slate-500">2021</text>
            <text x="130" y="195" text-anchor="middle" class="text-xs fill-slate-500">2022</text>
            <text x="190" y="195" text-anchor="middle" class="text-xs fill-slate-500">2023</text>
            <text x="250" y="195" text-anchor="middle" class="text-xs fill-slate-500">2024</text>
            <text x="310" y="195" text-anchor="middle" class="text-xs fill-slate-500">2025</text>
            <text x="35" y="25" text-anchor="end" class="text-xs fill-slate-500">1500</text>
            <text x="35" y="65" text-anchor="end" class="text-xs fill-slate-500">1200</text>
            <text x="35" y="105" text-anchor="end" class="text-xs fill-slate-500">900</text>
            <text x="35" y="145" text-anchor="end" class="text-xs fill-slate-500">600</text>
            <text x="35" y="185" text-anchor="end" class="text-xs fill-slate-500">300</text>
          </svg>
        </div>
      </div>

      <!-- 经费执行率饼图 -->
      <div class="glass-card rounded-2xl p-5">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-base font-bold text-slate-800">经费执行率分布</h3>
            <p class="text-xs text-slate-500 mt-0.5">在研项目经费执行情况统计</p>
          </div>
        </div>
        <div class="flex items-center gap-6">
          <div class="relative w-36 h-36">
            <svg class="w-full h-full -rotate-90" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="40" fill="none" stroke="#f1f5f9" stroke-width="12"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#3b82f6" stroke-width="12" stroke-dasharray="113 251" stroke-dashoffset="0" stroke-linecap="round"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#22d3ee" stroke-width="12" stroke-dasharray="95 251" stroke-dashoffset="-113" stroke-linecap="round"/>
              <circle cx="50" cy="50" r="40" fill="none" stroke="#e2e8f0" stroke-width="12" stroke-dasharray="43 251" stroke-dashoffset="-208" stroke-linecap="round"/>
            </svg>
            <div class="absolute inset-0 flex flex-col items-center justify-center">
              <span class="text-xl font-bold text-slate-800 number-font">856</span>
              <span class="text-xs text-slate-500">在研项目</span>
            </div>
          </div>
          <div class="flex flex-col gap-3">
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 rounded bg-blue-500"></div>
              <div>
                <div class="text-xs font-medium text-slate-700">执行中</div>
                <div class="text-xs text-slate-500">385个项目 (45%)</div>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 rounded bg-cyan-400"></div>
              <div>
                <div class="text-xs font-medium text-slate-700">已执行</div>
                <div class="text-xs text-slate-500">325个项目 (38%)</div>
              </div>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-3 h-3 rounded bg-slate-200"></div>
              <div>
                <div class="text-xs font-medium text-slate-700">待执行</div>
                <div class="text-xs text-slate-500">146个项目 (17%)</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 项目状态漏斗图 -->
      <div class="glass-card rounded-2xl p-5">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-base font-bold text-slate-800">立项→结题转化率</h3>
            <p class="text-xs text-slate-500 mt-0.5">项目全生命周期转化分析</p>
          </div>
          <div class="px-2 py-1 bg-emerald-50 rounded-lg">
            <span class="text-xs font-bold text-emerald-600">转化率: 78%</span>
          </div>
        </div>
        <div class="flex flex-col items-center justify-center h-48 gap-2">
          <!-- Funnel SVG -->
          <svg class="w-full h-full" viewBox="0 0 200 160">
            <!-- 申报阶段 -->
            <polygon points="20,10 180,10 160,35 40,35" fill="#3b82f6" opacity="0.9"/>
            <text x="100" y="26" text-anchor="middle" class="text-xs fill-white font-medium">申报 1,580</text>
            
            <!-- 立项阶段 -->
            <polygon points="40,40 160,40 145,65 55,65" fill="#3b82f6" opacity="0.8"/>
            <text x="100" y="56" text-anchor="middle" class="text-xs fill-white font-medium">立项 1,247</text>
            
            <!-- 中期阶段 -->
            <polygon points="55,70 145,70 130,95 70,95" fill="#3b82f6" opacity="0.7"/>
            <text x="100" y="86" text-anchor="middle" class="text-xs fill-white font-medium">中期 1,089</text>
            
            <!-- 结题阶段 -->
            <polygon points="70,100 130,100 115,125 85,125" fill="#3b82f6" opacity="0.6"/>
            <text x="100" y="116" text-anchor="middle" class="text-xs fill-white font-medium">结题 973</text>
            
            <!-- 转化率标注 -->
            <text x="170" y="50" text-anchor="start" class="text-xs fill-emerald-500">79%</text>
            <text x="155" y="82" text-anchor="start" class="text-xs fill-emerald-500">87%</text>
            <text x="140" y="112" text-anchor="start" class="text-xs fill-emerald-500">89%</text>
          </svg>
        </div>
      </div>
    </div>

    <!-- AI分析洞察 -->
    <div class="glass-card rounded-2xl p-5 border-l-4 border-purple-500 bg-gradient-to-r from-purple-50/50 to-transparent">
      <div class="flex items-center gap-2 mb-3">
        <div class="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
          <svg class="w-4 h-4 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
          </svg>
        </div>
        <h3 class="text-base font-bold text-slate-800">🤖 AI分析洞察</h3>
      </div>
      <div class="space-y-2">
        <div class="flex items-start gap-3 p-2.5 rounded-xl bg-white/60">
          <span class="w-1.5 h-1.5 rounded-full bg-purple-500 mt-2 flex-shrink-0"></span>
          <div>
            <span class="text-sm text-slate-700">本月申报项目质量评分平均<strong class="text-purple-600">4.2分</strong>，较去年同期提升<strong class="text-emerald-600">12%</strong></span>
          </div>
        </div>
        <div class="flex items-start gap-3 p-2.5 rounded-xl bg-white/60">
          <span class="w-1.5 h-1.5 rounded-full bg-purple-500 mt-2 flex-shrink-0"></span>
          <div>
            <span class="text-sm text-slate-700"><strong class="text-blue-600">高熵催化</strong>领域项目申报增长<strong class="text-emerald-600">35%</strong>，建议关注该领域专家资源储备情况</span>
          </div>
        </div>
        <div class="flex items-start gap-3 p-2.5 rounded-xl bg-white/60">
          <span class="w-1.5 h-1.5 rounded-full bg-purple-500 mt-2 flex-shrink-0"></span>
          <div>
            <span class="text-sm text-slate-700">AI模型检测到<strong class="text-amber-600">新能源电池</strong>方向申报热度持续上升，建议适当增加该领域立项指标</span>
          </div>
        </div>
      </div>
    </div>

    <!-- AI风险预警专区 -->
    <div class="glass-card rounded-2xl p-5 border-l-4 border-red-500">
      <div class="flex items-center justify-between mb-4">
        <div class="flex items-center gap-2">
          <div class="w-8 h-8 rounded-lg bg-red-50 flex items-center justify-center">
            <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
            </svg>
          </div>
          <h3 class="text-base font-bold text-slate-800">🚨 AI风险预警</h3>
          <span class="px-2 py-0.5 bg-red-100 text-red-600 rounded-full text-xs font-semibold">3项待处理</span>
        </div>
        <button class="text-xs text-blue-600 hover:text-blue-700 font-medium flex items-center gap-1">
          查看全部
          <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
          </svg>
        </button>
      </div>
      <div class="space-y-3">
        <div class="flex items-center justify-between p-3 rounded-xl bg-red-50/70 border border-red-100">
          <div class="flex items-start gap-3">
            <span class="text-red-500 text-lg">🔴</span>
            <div>
              <span class="text-sm font-medium text-slate-700">3个项目进度落后超过30天，需重点关注</span>
              <p class="text-xs text-slate-500 mt-1">涉及项目：2025AI003、2025BIO002、2025ENE001</p>
            </div>
          </div>
          <button class="px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs font-medium rounded-lg transition-colors">处理</button>
        </div>
        <div class="flex items-center justify-between p-3 rounded-xl bg-amber-50/70 border border-amber-100">
          <div class="flex items-start gap-3">
            <span class="text-amber-500 text-lg">🟡</span>
            <div>
              <span class="text-sm font-medium text-slate-700">12个项目经费执行率低于30%，接近年度审计节点</span>
              <p class="text-xs text-slate-500 mt-1">建议尽快推进经费使用，避免年底集中支出</p>
            </div>
          </div>
          <button class="px-3 py-1.5 bg-amber-500 hover:bg-amber-600 text-white text-xs font-medium rounded-lg transition-colors">查看</button>
        </div>
        <div class="flex items-center justify-between p-3 rounded-xl bg-red-50/70 border border-red-100">
          <div class="flex items-start gap-3">
            <span class="text-red-500 text-lg">🔴</span>
            <div>
              <span class="text-sm font-medium text-slate-700">科技重大专项类别中，2个项目存在结题风险</span>
              <p class="text-xs text-slate-500 mt-1">需加强过程监管，确保按期完成研究任务</p>
            </div>
          </div>
          <button class="px-3 py-1.5 bg-red-500 hover:bg-red-600 text-white text-xs font-medium rounded-lg transition-colors">处理</button>
        </div>
      </div>
    </div>

    <!-- Bottom Row -->
    <div class="grid grid-cols-3 gap-5">
      <!-- 计划类别TOP5 -->
      <div class="glass-card rounded-2xl p-5">
        <div class="flex items-center gap-2 mb-4">
          <div class="w-8 h-8 rounded-lg bg-blue-50 flex items-center justify-center">
            <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
            </svg>
          </div>
          <h3 class="text-sm font-bold text-slate-800">📊 计划类别 TOP5</h3>
        </div>
        <div class="space-y-3">
          <div v-for="(item, index) in topCategories" :key="index" class="flex items-center gap-3">
            <div class="w-6 h-6 rounded-lg flex items-center justify-center text-xs font-bold"
                 :class="index < 3 ? 'bg-gradient-to-br from-blue-500 to-cyan-400 text-white' : 'bg-slate-100 text-slate-500'">
              {{ index + 1 }}
            </div>
            <div class="flex-1">
              <div class="flex items-center justify-between mb-1">
                <span class="text-sm font-medium text-slate-700">{{ item.name }}</span>
                <span class="text-sm font-bold text-slate-800 number-font">{{ item.count }}</span>
              </div>
              <div class="h-1.5 rounded-full bg-slate-100 overflow-hidden">
                <div class="h-full rounded-full bg-gradient-to-r from-blue-500 to-cyan-400 transition-all duration-500"
                     :style="{ width: (item.count / 487 * 100) + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 成果产出排行榜 -->
      <div class="col-span-2 glass-card rounded-2xl p-5">
        <div class="flex items-center justify-between mb-4">
          <div class="flex items-center gap-2">
            <div class="w-8 h-8 rounded-lg bg-emerald-50 flex items-center justify-center">
              <svg class="w-4 h-4 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"/>
              </svg>
            </div>
            <h3 class="text-sm font-bold text-slate-800">🏆 成果产出排行榜</h3>
          </div>
          <div class="flex items-center gap-3">
            <div class="flex items-center gap-1 bg-slate-100 rounded-lg p-1">
              <button v-for="tab in outputTabs" :key="tab.key"
                      class="px-2.5 py-1 rounded-md text-xs font-medium transition-all"
                      :class="activeOutputTab === tab.key ? 'bg-white text-blue-600 shadow-sm' : 'text-slate-500 hover:text-slate-700'"
                      @click="activeOutputTab = tab.key">
                {{ tab.label }}
              </button>
            </div>
          </div>
        </div>

        <!-- Stats Summary -->
        <div class="flex items-center gap-6 mb-4 pb-4 border-b border-slate-100">
          <div class="flex items-center gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">234</span>
            <span class="text-xs text-slate-500">论文</span>
          </div>
          <div class="w-px h-6 bg-slate-200"></div>
          <div class="flex items-center gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">156</span>
            <span class="text-xs text-slate-500">专利</span>
          </div>
          <div class="w-px h-6 bg-slate-200"></div>
          <div class="flex items-center gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">89</span>
            <span class="text-xs text-slate-500">软著</span>
          </div>
          <div class="w-px h-6 bg-slate-200"></div>
          <div class="flex items-center gap-2">
            <span class="text-2xl font-bold text-slate-800 number-font">45</span>
            <span class="text-xs text-slate-500">获奖</span>
          </div>
        </div>

        <!-- Dimension Switcher -->
        <div class="flex items-center gap-2 mb-3">
          <span class="text-xs text-slate-500">维度:</span>
          <div class="flex items-center gap-1">
            <button v-for="dim in dimensions" :key="dim.key"
                    class="px-2 py-1 rounded text-xs transition-colors"
                    :class="activeDimension === dim.key ? 'bg-blue-50 text-blue-600 font-medium' : 'text-slate-500 hover:bg-slate-50'"
                    @click="activeDimension = dim.key">
              {{ dim.label }}
            </button>
          </div>
        </div>

        <!-- Ranking List -->
        <div class="grid grid-cols-2 gap-3">
          <div v-for="(item, index) in outputRankings" :key="index" 
               class="flex items-center gap-3 p-2.5 rounded-xl bg-slate-50/50 hover:bg-slate-50 transition-colors">
            <div class="w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold"
                 :class="index < 3 ? 'bg-gradient-to-br from-amber-400 to-orange-500 text-white' : 'bg-slate-200 text-slate-600'">
              {{ index + 1 }}
            </div>
            <div class="flex-1 min-w-0">
              <div class="text-sm font-medium text-slate-700 truncate">{{ item.name }}</div>
              <div class="text-xs text-slate-500">{{ item.subtitle }}</div>
            </div>
            <div class="text-right">
              <div class="text-base font-bold text-slate-800 number-font">{{ item.value }}</div>
              <div class="text-xs text-slate-400">{{ item.unit }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Quick Access -->
    <div class="grid grid-cols-4 gap-4">
      <router-link to="/guide-refine" class="quick-access-card glass-card rounded-xl p-4 flex items-center gap-3 hover:shadow-lg transition-all group">
        <div class="w-11 h-11 rounded-xl bg-gradient-to-br from-blue-500 to-cyan-400 flex items-center justify-center group-hover:scale-110 transition-transform">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"/>
          </svg>
        </div>
        <div>
          <div class="text-sm font-bold text-slate-800">指南凝练</div>
          <div class="text-xs text-slate-500">第 1 环节 · 待审核 12</div>
        </div>
      </router-link>

      <router-link to="/declare-audit" class="quick-access-card glass-card rounded-xl p-4 flex items-center gap-3 hover:shadow-lg transition-all group">
        <div class="w-11 h-11 rounded-xl bg-gradient-to-br from-purple-500 to-pink-400 flex items-center justify-center group-hover:scale-110 transition-transform">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
          </svg>
        </div>
        <div>
          <div class="text-sm font-bold text-slate-800">申报审核</div>
          <div class="text-xs text-slate-500">第 2 环节 · 待审核 28</div>
        </div>
      </router-link>

      <router-link to="/project-list" class="quick-access-card glass-card rounded-xl p-4 flex items-center gap-3 hover:shadow-lg transition-all group">
        <div class="w-11 h-11 rounded-xl bg-gradient-to-br from-emerald-500 to-teal-400 flex items-center justify-center group-hover:scale-110 transition-transform">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
        </div>
        <div>
          <div class="text-sm font-bold text-slate-800">项目流程管理</div>
          <div class="text-xs text-slate-500">全流程跟踪 · 856个项目</div>
        </div>
      </router-link>

      <router-link to="/knowledge-base" class="quick-access-card glass-card rounded-xl p-4 flex items-center gap-3 hover:shadow-lg transition-all group">
        <div class="w-11 h-11 rounded-xl bg-gradient-to-br from-amber-500 to-orange-400 flex items-center justify-center group-hover:scale-110 transition-transform">
          <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"/>
          </svg>
        </div>
        <div>
          <div class="text-sm font-bold text-slate-800">项目数据管理</div>
          <div class="text-xs text-slate-500">知识库检索 · 2,847条</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Dashboard',
  methods: {
    goToAIAssistant(agent) {
      this.$router.push({
        path: '/ai-assistant',
        query: { agent: agent }
      })
    }
  },
  data() {
    return {
      currentDate: '2025-03-29',
      activeOutputTab: 'paper',
      activeDimension: 'unit',
      outputTabs: [
        { key: 'paper', label: '论文' },
        { key: 'patent', label: '专利' },
        { key: 'software', label: '软著' },
        { key: 'award', label: '获奖' },
        { key: 'talent', label: '人才培养' }
      ],
      dimensions: [
        { key: 'unit', label: '单位' },
        { key: 'person', label: '个人' },
        { key: 'field', label: '领域' }
      ],
      topCategories: [
        { name: '自然科学基金', count: 487 },
        { name: '科技重大专项', count: 312 },
        { name: '重点研发计划', count: 198 },
        { name: '技术创新引导', count: 156 },
        { name: '基地和人才专项', count: 94 }
      ],
      outputRankings: [
        { name: '清华大学', subtitle: '材料科学与工程学院', value: 156, unit: '篇' },
        { name: '北京大学', subtitle: '化学与分子工程学院', value: 142, unit: '篇' },
        { name: '中科院化学所', subtitle: '分子纳米结构与纳米技术', value: 128, unit: '篇' },
        { name: '浙江大学', subtitle: '高分子科学与工程学系', value: 115, unit: '篇' },
        { name: '复旦大学', subtitle: '材料科学系', value: 98, unit: '篇' },
        { name: '南京大学', subtitle: '化学化工学院', value: 87, unit: '篇' }
      ]
    }
  }
}
</script>

<style scoped>
.premium-metric-card {
  background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255,255,255,0.6);
  box-shadow: 0 4px 20px rgba(0,0,0,0.03), 0 1px 2px rgba(0,0,0,0.02);
  transition: all 0.3s ease;
}

.premium-metric-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 28px rgba(0,0,0,0.06), 0 2px 4px rgba(0,0,0,0.03);
}

.ai-agent-card {
  transition: all 0.3s ease;
}

.ai-agent-card:hover {
  transform: translateY(-2px);
}

.quick-access-card {
  transition: all 0.3s ease;
}

.quick-access-card:hover {
  transform: translateY(-2px);
}

.number-font {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-feature-settings: 'tnum';
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.8;
  }
}

.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
</style>
